import {Component, Input} from '@angular/core';
import {ViewField} from '../../core/definitions/object-view';

@Component({
    selector: 'app-display-field-title',
    templateUrl: './display-field-title.component.html',
    styleUrls: ['./display-field-title.component.scss'],
    standalone: false
})
export class DisplayFieldTitleComponent {

  @Input() field: ViewField;
  @Input() titleClass: string;
}
